import React from "react";
import { withTranslation } from "react-i18next";
import Powers from "./powers.jsx";
import Allunits from "./allunits.jsx";
import SearchBar from "./searchBar";

class FilterSwitcher extends React.Component {
  state = {
    isStandartsVisible: true,
  };

  render() {
    const { t } = this.props;

    return (
      <div className="filter-tab-content">
        <ul className="l1 filter">
          <li className="label label-swtich">
            <div className="filter-switch">
              {this.props.filters.map((filter, i) => (
                <button
                  key={i}
                  className={
                    "filter-tab-button" +
                    (this.props.activeFilter == i ? " selected" : "")
                  }
                  onClick={this.props.switchFilter(i)}
                  data-target={filter.id}
                >
                  {t(filter.maingroup)}
                </button>
              ))}
            </div>
          </li>

          <li className="label search-label">
            <h3>{t("Search products")}</h3>
          </li>
          <li className="search-item">
            <SearchBar />
          </li>

          <li className="label">
            <h3
              className={this.state.isStandartsVisible ? "open" : "closed"}
              onClick={() =>
                this.setState({
                  isStandartsVisible: !this.state.isStandartsVisible,
                })
              }
            >
              {t("Power supply/Unit")}
            </h3>
          </li>

          <div
            className="standarts"
            style={{
              display: this.state.isStandartsVisible ? "block" : "none",
            }}
          >
            <Powers powers={this.props.powers} />
          </div>
        </ul>
      </div>
    );
  }
}

export default withTranslation()(FilterSwitcher);
